import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Paper, Dialog, DialogActions, DialogContent, DialogTitle, Container, Button, Grid} from '@material-ui/core'

import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import InfoIcon from '@material-ui/icons/Info';

import theme from '../theme';

class AlertDialog_ extends React.Component{

    handleConfirm(){

        if(this.props.onConfirm) this.props.onConfirm()

        this.props.onAction({type: 'ALERT_DIALOG_CLOSE'})

    }

    handleClose(){

        //this.props.onClose()

        this.props.onAction({type: 'ALERT_DIALOG_CLOSE'})
        
    }   

    render() {
        const {t} = this.props

        return (
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{this.props.title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:350}}>
            
            <Grid  key="1" container direction="row" spacing={1} style={{ padding:5}}>
                <Grid xs={2} item >
                    <InfoIcon fontSize='large' />
                </Grid>
                <Grid item xs={10} align="left" style={{paddingTop:10}}>
                    {this.props.message}
                </Grid>
            </Grid>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleConfirm.bind(this)} variant="contained" color="primary">
            {t('OK')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }

}

export const AlertDialog = withTranslation()(AlertDialog_);